import React from "react";
import { FormElements } from "../../../../../../shared/bootstrap/form/FormElements";
import { useLanguageForShared } from "../../../../../../shared/utils/languages/useLanguageForShared";

export function TemplateBombolaLegge64896({ dataForm, changeValue, errors, setData, isSubmit }) {
  const { t } = useLanguageForShared();

  const formStructure = [
    {
      name: "formato",
      type: "select",
      label: `${t("bombolaLegge64896.formato")}*`,
      options: [
        { label: t("bombolaLegge64896.formato_14"), value: "14" },
        { label: t("bombolaLegge64896.formato_27"), value: "27" },
      ],
      dataElement: { type: "text" },
      col: { xs: "12", sm: "6", lg: "4", xl: "4" }
    },
    {
      name: "quantita",
      type: "input",
      label: `${t("bombolaLegge64896.quantita")}*`,
      dataElement: {
        placeholder: t("bombolaLegge64896.quantita_placeholder"),
        type: "number",
        min: "1"
      },
      col: { xs: "12", sm: "6", lg: "4", xl: "4" }
    },
    {
      name: "note",
      type: "textarea",
      label: t("sg.additionalNotes"),
      col: { xs: "12" }
    }
  ];

  return (
    <>
      <FormElements
        structure={formStructure}
        dataForm={dataForm}
        changeValue={changeValue}
        errors={errors}
        isSubmit={isSubmit}
      />
    </>
  );
}
